// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f692218f","977":"fdb1cf64"}[chunkId] + ".chunk.js";
};